import classNames from 'classnames';
import { useEffect } from 'react';
import { Input } from '../Inputs/Input';
import styles from './SearchBox.module.scss';
export interface SearchBoxProps {
	className?: string;
	id?: string;
	searchActionAriaLabel: string;
	searchPlaceholder: string;
	searchWord: (word: string) => void;
	width?: 'fullWidth';
	query: string;
	handleChangeCallback: (queryCallback: string) => void;
}

export const SearchBox = ({
	className,
	id,
	searchActionAriaLabel,
	searchPlaceholder,
	searchWord,
	width = 'fullWidth',
	query,
	handleChangeCallback,
}: SearchBoxProps) => {
	useEffect(() => {
		const keyDownHandler = (event) => {
			if (event.key === 'Enter') {
				event.preventDefault();
				searchWord(query);
			}
		};

		document.addEventListener('keydown', keyDownHandler);
		return () => {
			document.removeEventListener('keydown', keyDownHandler);
		};
	}, [searchActionAriaLabel, searchPlaceholder, searchWord, query]);

	return (
		<div className={classNames(styles.SearchBox, styles[`SearchBox___${width}`], className)}>
			<Input
				id={id}
				type="search"
				placeholder={searchPlaceholder}
				textLeft={true}
				button={{ icon: 'soeg', ariaLabel: searchActionAriaLabel, onClick: () => searchWord(query), type: 'button' }}
				autoComplete="off"
				value={query}
				onChange={(e) => handleChangeCallback(e.target.value)}
			/>
		</div>
	);
};
